// Customer Buy Item Actions Configuration
// Actions available to customers for buy-type order items

import { 
  ArrowPathIcon as ReturnIcon, 
  EyeIcon, 
  StarIcon,
  XMarkIcon as XIcon,
  PencilIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';

export const customerBuyItemActions = [
  // Cancel Item (processing + pending)
  {
    id: 'cancel_item_user',
    label: 'Cancel Item',
    type: 'secondary',
    icon: XIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'processing',
      itemStatus: 'pending',
      timeConstraints: { within24Hours: true },
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'CancelItemModal',
      mutation: 'useCancelOrderItemMutation',
      api: 'orderItemApi'
    }
  },
  
  // Cancel Item (processing + processing)
  {
    id: 'cancel_item_user_processing',
    label: 'Cancel Item',
    type: 'secondary',
    icon: XIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'processing',
      itemStatus: 'processing',
      timeConstraints: { within24Hours: true },
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'CancelItemModal',
      mutation: 'useCancelOrderItemMutation',
      api: 'orderItemApi'
    }
  },

  

  // Request Return (delivery_completed_to_customer + delivered)
  // {
  //   id: 'request_return',
  //   label: 'Request Return',
  //   type: 'secondary',
  //   icon: ReturnIcon,
  //   conditions: {
  //     userRole: 'customer',
  //     entityType: 'orderItem',
  //     itemType: 'buy',
  //     fulfillmentGroupStatus: 'delivery_completed_to_customer',
  //     itemStatus: 'delivered',
  //     timeConstraints: { maxDaysAfterDelivery: 30 },
  //     noActiveReturn: true,
  //     multipleItemsInGroup: true
  //   },
  //   action: {
  //     type: 'modal',
  //     component: 'RequestReturnModal',
  //     mutation: 'useInitiateItemReturnMutation',
  //     api: 'orderItemApi'
  //   }
  // },

  // Review Product (delivery_completed_to_customer + delivered)
  {
    id: 'review_product',
    label: 'Review Product',
    type: 'secondary',
    icon: StarIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'delivery_completed_to_customer',
      itemStatus: 'delivered',
      noExistingReview: true
    },
    action: {
      type: 'redirect',
      target: '/product/{productId}/review'
    }
  },

  // Review Product (return_requested + return_requested_by_customer)
  {
    id: 'review_product_return_requested',
    label: 'Review Product',
    type: 'secondary',
    icon: StarIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'return_requested',
      itemStatus: 'return_requested_by_customer',
      noExistingReview: true
    },
    action: {
      type: 'redirect',
      target: '/product/{productId}/review'
    }
  },

  // Note: No Cancel Return action in item

  // Start Return (return_approved + return_approved_by_merchant)
  {
    id: 'start_return',
    label: 'Start Return',
    type: 'primary',
    icon: ReturnIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'return_approved',
      itemStatus: 'return_approved_by_merchant'
    },
    action: {
      type: 'redirect',
      target: '/dashboard/returns/{itemId}/return-shipping'
    }
  },

  // Track Return Shipment (return_shipped + return_shipped)
  {
    id: 'track_return_shipment',
    label: 'Track Return Shipment',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'return_shipped',
      itemStatus: 'return_shipped',
      hasReturnTracking: true,
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetReturnTrackingQuery',
      api: 'orderItemApi'
    }
  },

  // Review Product (return_delivered + return_delivered)
  {
    id: 'review_product_returned',
    label: 'Review Product',
    type: 'secondary',
    icon: StarIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'return_delivered',
      itemStatus: 'return_delivered',
      noExistingReview: true
    },
    action: {
      type: 'redirect',
      target: '/product/{productId}/review'
    }
  },

  // Contact Support (delivery_failed + delivered)
  {
    id: 'contact_support',
    label: 'Contact Support',
    type: 'secondary',
    icon: PencilIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'delivery_failed',
      itemStatus: 'delivered'
    },
    action: {
      type: 'redirect',
      target: '/contact'
    }
  },

  // Request Redelivery (delivery_failed + delivered)
  {
    id: 'request_redelivery',
    label: 'Request Redelivery',
    type: 'warning',
    icon: ExclamationTriangleIcon,
    conditions: {
      userRole: 'customer',
      entityType: 'orderItem',
      itemType: 'buy',
      fulfillmentGroupStatus: 'delivery_failed',
      itemStatus: 'delivered'
    },
    action: {
      type: 'modal',
      component: 'RequestRedeliveryModal',
      // TODO: Create redelivery API
      api: {
        endpoint: '/orders/{orderId}/items/{itemId}/request-redelivery',
        method: 'POST'
      }
    }
  }
]; 